import { Component, inject, input } from '@angular/core';
import { SlideOutComponent } from '../../../shared/components/slide-out/slide-out.component';
import { FaqAccordionItemComponent } from '../../components/faq-accordion-item/faq-accordion-item.component';
import { IconCircleCheckComponent } from '../../../shared/components/icon-circle-check/icon-circle-check.component';
import { LogoBestEggWhiteComponent } from '../../../shared/components/logo-bestegg-white/logo-bestegg-white.component';
import { Offer } from '../../models/offers.model';
import { SlideOutService } from '../../../customer-hub/services/slide-out.service';
import { OffersService } from '../../services/offers.service';

@Component({
  standalone: true,
  selector: 'app-hsl-slide-out',
  imports: [SlideOutComponent, FaqAccordionItemComponent, IconCircleCheckComponent, LogoBestEggWhiteComponent],
  templateUrl: './hsl-slide-out.component.html',
  styleUrl: './hsl-slide-out.component.scss',
})
export class HslSlideOutComponent {
  readonly isSlideOutOpen = input.required<boolean>();
  readonly offer = input.required<Offer | null>();

  private readonly slideOutService = inject(SlideOutService);
  private readonly offersService = inject(OffersService);

  closeSlideOut() {
    this.slideOutService.close();
  }

  fireGetOfferEvents() {
    const offer = this.offer();
    const placement = this.slideOutService.activePlacement();
    this.offersService.trackLinkClickEvent({
      offer,
      placement,
      siteSection: 'hub',
      fsEvent: '[Auth] Hub HSL offer clicked',
    });
  }

  openDisclosure() {
    this.offersService.openDisclosures(this.offer().subProductType);
  }
}
